import React from "react";
import { Card } from "react-bootstrap";
import "../../Styles/SideBar.css";
import Logo from "../../Assets/Images/Logo.png";
import { ReactComponent as DashboardIcon } from "../../Assets/Icons/dashboardIcon.svg";
import { ReactComponent as SubscriptionIcon } from "../../Assets/Icons/subscriptionIcon.svg";
import { ReactComponent as SettingIcon } from "../../Assets/Icons/settingIcon.svg";
import { ReactComponent as PaymentIcon } from "../../Assets/Icons/paymentIcon.svg";
import { ReactComponent as CreateIcon } from "../../Assets/Icons/createIcon.svg";
import LogOutIcon from "../../Assets/Icons/logOutIcon.svg";
import { Link } from "react-router-dom";

export default function SideBar({ handleSidebar }) {
  return (
    <div className="sidebar-con" onClick={() => handleSidebar(false)}>
      <Card
        style={{
          width: "14.1rem",
          height: "100vh",
          border: "none",
          backgroundColor: "#27293D",
          marginLeft: "0",
          paddingLeft: "0",
          borderRadius: "0",
          zIndex: 1,
          //   position: "absolute",
        }}
      >
        <div className="sidebar-parent">
          <div className="logo">
            <img src={Logo} alt="logo" />
          </div>
          <div className="sidebar-sec-con">
            <div>
              <Link style={{ textDecoration: "inherit" }} to="/super-admin">
                <div className="sidebar-sec-one-heading">
                  <p>Super Admin</p>
                </div>
              </Link>
              <div className="sidebar-link-con">
                <Link
                  style={{ textDecoration: "inherit", width: "100%" }}
                  to="/"
                >
                  <div className="sidebar-link">
                    <DashboardIcon
                      style={{ width: "1.25rem", heigth: "1.25rem" }}
                      fill="#9D9D9D"
                    />
                    <p>Dashboard</p>
                  </div>
                </Link>
                <Link
                  style={{ textDecoration: "inherit", width: "100%" }}
                  to="/payment-history"
                >
                  <div className="sidebar-link">
                    <SubscriptionIcon
                      style={{ width: "1.25rem", heigth: "1.25rem" }}
                      fill="#9D9D9D"
                    />
                    <p>Subscription</p>
                  </div>
                </Link>
                <Link
                  style={{ textDecoration: "inherit", width: "100%" }}
                  to="/admin-profile-setting"
                >
                  <div className="sidebar-link">
                    <SettingIcon
                      style={{ width: "1.25rem", heigth: "1.25rem" }}
                      fill="#9D9D9D"
                    />
                    <p>Setting</p>
                  </div>
                </Link>
              </div>
            </div>
            <div>
              <Link
                style={{ textDecoration: "inherit", width: "100%" }}
                to="/admin-merchant"
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "1rem",
                    justifyContent: "start",
                    paddingLeft: "1.6rem",
                  }}
                  className="sidebar-sec-one-heading"
                >
                  <DashboardIcon
                    style={{ width: "1.25rem", heigth: "1.25rem" }}
                    fill="#27293D"
                  />
                  <p>Merchant</p>
                </div>
              </Link>
              <div className="sidebar-link-con">
                <Link
                  style={{ textDecoration: "inherit", width: "100%" }}
                  to="/merchant-account"
                >
                  <div className="sidebar-link">
                    <SubscriptionIcon
                      style={{ width: "1.25rem", heigth: "1.25rem" }}
                      fill="#9D9D9D"
                    />
                    <p>Dashboard</p>
                  </div>
                </Link>
                <Link style={{ textDecoration: "inherit", width: "100%" }}
                  to="/payment-behalf-merchant">
                <div className="sidebar-link">
                  <PaymentIcon
                    style={{ width: "1.25rem", heigth: "1.25rem" }}
                    fill="#9D9D9D"
                  />
                  <p>Payments</p>
                </div>
                </Link>
              </div>
            </div>
            <div>
              <Link style={{ textDecoration: "inherit", width: "100%" }} to='/merchant-send-email'>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "1rem",
                  justifyContent: "start",
                  paddingLeft: "1.6rem",
                }}
                className="sidebar-sec-one-heading"
              >
                <DashboardIcon
                  style={{ width: "1.25rem", heigth: "1.25rem" }}
                  fill="#27293D"
                />
                <p>CMS</p>
              </div>
              </Link>
              <div className="sidebar-link-con">
                <Link style={{ textDecoration: "inherit", width: "100%" }} to='/admin-create-blog'>
                <div className="sidebar-link">
                  <CreateIcon
                    style={{ width: "1.25rem", heigth: "1.25rem" }}
                    fill="#9D9D9D"
                  />
                  <p>Create Blog</p>
                </div>
                </Link>
                <Link style={{ textDecoration: "inherit", width: "100%" }} to='/create-admin'>
                <div className="sidebar-link">
                  <CreateIcon
                    style={{ width: "1.25rem", heigth: "1.25rem" }}
                    fill="#9D9D9D"
                  />
                  <p>Create Admin</p>
                </div>
                </Link>
              </div>
            </div>
          </div>
          <div className="sidebar-logout">
            <img src={LogOutIcon} />
            <p>Log out</p>
          </div>
        </div>
      </Card>
    </div>
  );
}
